// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__BEwKl","loader":"Loader_loader__lqUPL","load":"Loader_load__2c9JO","content":"Loader_content__sZf-G","process":"Loader_process__lch5g"};